//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
import { isVarArray, isVarObject } from './merge-objects';
export function cloneDeepObject(obj) {
    if (isVarObject(obj)) {
        const result = {};
        for (const key of Object.keys(obj)) {
            result[key] = cloneDeepObject(obj[key]);
        }
        return result;
    }
    else if (isVarArray(obj)) {
        const result = [];
        for (let index = 0; index < obj.length; index++) {
            result[index] = cloneDeepObject(obj[index]);
        }
        return result;
    }
    else {
        return obj;
    }
}
